var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Responsive"},[(_vm.isMobile)?_c('Mobile'):_c('Pc')],1)}
var staticRenderFns = []

export { render, staticRenderFns }